module.exports = {"key":"hello ukrain","submit":"Надіслати відгук!","hide":"Сховати це","skip":"Перейти до наступного запитання","placeholder":"Опишіть, як ви це відчуваєте..."}


//////////////////
// WEBPACK FOOTER
// ./src/translations/uk.json
// module id = 450
// module chunks = 0